import * as React from "react";
import { useTheme } from "styled-components";

import { style, Icon } from "./Symbolicons";

export const Truck = (props: Icon): React.ReactElement => {
  const theme = useTheme();

  return (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke={props.color || theme.palette.grey600}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21.8355 24.6699H11.3911" />
      <path d="M25.8318 24.6702H28.5049C29.2416 24.6702 29.8388 24.073 29.8388 23.3363V15.1801C29.8388 14.8409 29.7741 14.5048 29.6481 14.1898L27.841 9.67336C27.4358 8.66063 26.4549 7.99658 25.3641 7.99658H20.5016" />
      <path d="M29.8389 17.3336H25.1702C24.8019 17.3336 24.5033 17.035 24.5033 16.6667V11.998H28.7717" />
      <path d="M25.2457 23.2608C25.818 23.833 25.9892 24.6936 25.6795 25.4413C25.3699 26.189 24.6403 26.6765 23.8311 26.6765C23.0218 26.6766 22.2922 26.1891 21.9825 25.4415C21.6728 24.6938 21.8439 23.8332 22.4161 23.261L22.4162 23.2608C22.7914 22.8856 23.3003 22.6748 23.831 22.6748C24.3616 22.6748 24.8705 22.8856 25.2457 23.2608V23.2608" />
      <path d="M10.573 23.2609C11.1452 23.8332 11.3165 24.6937 11.0068 25.4414C10.6972 26.1891 9.96761 26.6766 9.15834 26.6767C8.34908 26.6767 7.61948 26.1893 7.30975 25.4416C7.00002 24.694 7.17116 23.8334 7.74336 23.2611L7.74376 23.2607C8.11895 22.8855 8.62782 22.6748 9.15841 22.6748C9.689 22.6749 10.1978 22.8857 10.5729 23.2609V23.2609" />
      <path d="M7.16268 24.67H4.4949C3.75821 24.67 3.16101 24.0728 3.16101 23.3361V6.6625C3.16101 5.92582 3.75821 5.32861 4.4949 5.32861H19.1677C19.9044 5.32861 20.5016 5.92582 20.5016 6.6625V18.6675" />
      <path d="M20.5016 18.6674H3.16101" />
    </svg>
  );
};
